import { useState } from "react";
import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import SearchBar from "src/SharedComponents/SearchBar/SearchBar";

interface QAndA {
    question: string;
    answer: string | JSX.Element;
}

const faqData: QAndA[] = [
    {
        question: "How can I add my colleagues to Aura?",
        answer:
        (
            <> 
              Use the clinic portal's "Users" tab and "+ New User" button. A registration link will be emailed to the new user.
            </>
        )
    },
    {
        question: "What's the difference between admins and members?",
        answer: "Admins have full writing access, can manage users, update software, and release seats. Members have full app access and view only rights on the clinic portal."
    },
    {
        question: "Why is my Aura App crashing?",
        answer: (
            <>
                We often notice that the Aura App crashes when the personal device doesn't meet the system requirements, particularly if it lacks the necessary <strong>16GB of RAM</strong>. Devices with less RAM are more likely to experience crashes.
            </>
        )
    },
    {
        question: "Can my second device have only 8GB RAM?",
        answer: "No, all devices need to have 16GB RAM to run smoothly, even when using the Cloud storage. Operations such as 3D reconstruction, volume comparison and vector analysing are powerful and need the 16GB RAM."
    },
    {
        question: "Is there a limitation to the number of users and devices?",
        answer: "You can create unlimited user accounts and install the Aura App on as many devices as you like. However, concurrent usage is restricted by the limits of your subscribed Software Suite. If you need additional seats, you can easily upgrade your Software Suite at any time via the Clinic Portal. Keep in mind that Aura Capture Devices are designed for single-user operation during data capture."
    },
    {
        question: "How do I know if I have the newest app version installed and how can I update it?",
        answer: "A notification banner appears if updates are available. Update via the Apple Store for Mac/iPad or directly through the banner on Windows."
    },
    {
        question: "How do I know if my Aura capture device is up to date and how can I update it?",
        answer: "A notification banner appears if an update for your Capture Device is available. To execute the update, connect the device to WiFi, visit your Clinic Portal and run the update. The process takes a few minutes with LED indicators showing progress."
    },
    {
        question: "How can I improve the quality of the 3D model?",
        answer: "Ensure patient's hair is tied away and make up is removed. In addition, ensure the patient is positioned, captured within tolerance and ears aren't covered."
    },
    {
        question: "What can I do to make the reconstruction of the 3D model faster?",
        answer: "Ensure your device meets system requirements, isn't on battery saving mode, and close power-consuming apps. Reconstruction on iPads and MacBooks takes on average less than 60 seconds."
    },
    {
        question: "How can I improve the consistency of the skin analysis?",
        answer: "Clean the skin before capture to avoid inaccuracies from cosmetics; allow time for skin to normalise after cleaning."
    },
    {
        question: "Does the patient need to have their eyes closed during capture?",
        answer: "Capture quality isn't affected by eye position; open eyes during positioning is recommended."
    },
    {
        question: "How accurate is the 3D model?",
        answer: "Aura's model accuracy is 0.1mm."
    },
    {
        question: "Why does the skin tone on Aura look different from a normal photograph?",
        answer: "Neither the camera, or the Aura device show the \"full and clear true colour\". Aura has a calibrated camera system and strong light that compensates also for all external light and makes sure that each capture is consistent and that external light does not impact the colour temperature of the reconstruction."
    },
    {
        question: "Can the Aura device detect sun damage?",
        answer: "Yes, using special filters and complex algorithms, the Aura device measures melanin concentration in the epidermis without needing Wood's light or UV light, with sun damage indicators visible in brown spots and texture features."
    },
    {
        question: "What are the skin analysis scores based on?",
        answer: "Wrinkles are based on the Lemperle Wrinkle Score, scored for Aura from 1-5; all other features are scored from 1 to 5 based on extensive data and dermatologist input."
    },
    {
        question: "How to improve the quality of volume and vector?",
        answer: "Ensure consistent patient positioning for accurate before-and-after comparisons. Patients need to be positioned within tolerance otherwise the capture will need to be repeated."
    },
    {
        question: "Why does the volume comparison show different values than injected?",
        answer: "The face is not a rigid obstacle. The volume injected interacts with the tissue and can be absorbed or cause inflammation. Due to this it is possible that the values in volume comparison differ from the injected volume."
    },
    {
        question: "Is Cloud storage mandatory and what should I do, if I need more storage?",
        answer: "No, data is not saved to the Cloud unless it is enabled through the Clinic Portal. If your Cloud storage limit is exceeded, you can easily upgrade your Aura Software package directly within the Clinic Portal."
    },
    {
        question: "What's the difference between deleting a patient in the app and clicking \"Free up space\"?",
        answer: "Deleting removes patient data from Cloud and devices; freeing up space clears local storage only. We recommend not deleting patients data as it can't be recovered."
    },
    {
        question: "Is the Aura Cloud secure?",
        answer: "Yes – The Aura Cloud is hosted in Central Europe via Microsoft Azure, meeting industry standards and certifications."
    }
];

const Faq = () => {

    const [searchText, setSearchText] = useState<string>('');

    // Filter FAQ data based on search text
    const filteredFaqData = faqData.filter(item => {
        const searchLower = searchText.toLowerCase();
        const questionMatch = item.question.toLowerCase().includes(searchLower);
        
        // Handle both string and JSX.Element answers
        let answerMatch = false;
        if (typeof item.answer === 'string') {
            answerMatch = item.answer.toLowerCase().includes(searchLower);
        } else {
            // For JSX elements, we'll search in the text content
            const answerText = JSON.stringify(item.answer).toLowerCase();
            answerMatch = answerText.includes(searchLower);
        }
        
        return questionMatch || answerMatch;
    });

  return (
    <>
     <div style={{marginLeft:'56px'}}>
            <div className="row mb-5 mt-2" style={{width:"95%"}}>
                <SearchBar onChange={(text:string) => {setSearchText(text) }} />
            </div>
    </div>
    {filteredFaqData.map((item, index) => (
        <GridViewCollapase key={index} title={item.question} id={`${index + 1}`}>
            <div>
             <hr className="m-0 ds-text-primary"/>
        </div>
          <div className='col-12 d-flex p-3'>     
             <div  style={{marginLeft: '12px', marginTop:'4px', marginBottom:'8px'}}>
                {item.answer}
            </div>
          </div>
        </GridViewCollapase>
      ))}
       
       
    </>
  );
}

export default Faq;